<!--
 * @Description:: 请补充填写
 * @Version: 请配置版本号
 * @Author: xiaobai
 * @Date: 2021-06-11 14:59:11
 * @LastEditors: smallWhite
 * @LastEditTime: 2022-12-20 11:03:21
 * @FilePath: /fujian-official-website/src/views/news/components/industry_news.vue
-->
<template>
  <div class="news_contents" style="padding-top:10px">
      <img v-if="loading" class="loading_img" src="../../../assets/imgaes/loading.7.gif">
    <div v-else class="news_contents_a" style="margin-top:20px">
      <el-table
      :data="newsList"
      stripe
      :header-cell-style="{'background':'#f5f5f5'}"
      style="width: 100%;border:1px solid #d9d9d9">
      <el-table-column
        prop="title"
        label="分享标题">
      </el-table-column>
      <el-table-column
        label="分享链接">
        <template slot-scope="scope">
          <a style="color:rgba(0, 92, 199, 1)" :href="scope.row.introduction" target="_bank">{{scope.row.introduction}}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间">
      </el-table-column>
    </el-table>
      <el-pagination
      style="margin-top: 20px; text-align: right;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next"
      :total="total">
    </el-pagination>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data(){
    return{
      loading:true,
      newsList:[],
      pageNum:1,
      pageSize:10,
      total:0
    }
  },
  mounted(){
    this.getList()
  },
  methods:{
    getList(){
      this.loading = true
      axios.post('/home/news', { 
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: 1
      }).then((res) => {
        this.loading = false
        this.total = parseInt(res.data.data.total)  
        const newsList = res.data.data.newsList
        newsList.map(item=>{
          this.$set(item,'imgUrl',res.data.data.imgUrl +'/'+ item.url)
        })
        this.newsList = newsList
        this.goTop()
      })
    },
    gotoDetails(item){
      this.$router.push({
        path:'/news_details',
        query:{
          id:item.id
        }
      })
    },
    handleSizeChange(val) {
        this.pageSize = val
        this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    goTop() {
      var timer = null
      cancelAnimationFrame(timer)
      timer = requestAnimationFrame(function fn() {
        var oTop = document.body.scrollTop || document.documentElement.scrollTop
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 50
          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
        }
      })
    },
  }
}
</script>

<style>

</style>